var map = {
	"./1_1_1.png": 2612,
	"./1_2_1.png": 6753,
	"./1_3_1.png": 1633,
	"./1_4_1.png": 9984,
	"./2_1_1.png": 5807,
	"./2_2_1.png": 3130,
	"./3_1_1.png": 4514,
	"./3_2_1.png": 1939,
	"./4_1_1.png": 2502,
	"./4_2_1.png": 836,
	"./4_3_1.png": 5793,
	"./4_4_1.png": 4693,
	"./5_1_1.png": 6725,
	"./5_2_1.png": 3942,
	"./99_1_1.png": 7528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2084;